<div class="fixed top-0 left-0 right-0 bottom-0 bg-(--loading-overlay-color) opacity-95 z-2"></div>
<div class="fixed inset-0 z-3 overflow-y-auto">
    <div class="min-h-dvh flex flex-col justify-center items-center py-8">
  <span class="w-full px-3 lg:max-w-6xl">
    <span class="flex flex-col mb-5 gap-y-5">
      <div class="text-white text-3xl font-semibold mb-1">Project Information</div>
      <div class="text-white text-md font-semibold">Project Title</div>
    </span>
    <mat-form-field appearance="fill" id="new-project" class="w-full text-white">
      <input matInput class="" [value]="projectName()" (input)="onNameInput($event)" />
      <mat-hint class="text-(--hint-color)">Max 100 characters. Must be unique. Letters, numbers,
        spaces, and dashes only.</mat-hint>
    </mat-form-field>
    <span class="flex flex-row gap-5 mt-5">
      @for (e of errors(); track $index) {
      <p class="text-white text-md font-semibold">{{ e }}</p>
      }
    </span>
    <span class="flex flex-row gap-5 mt-5">
      <button (click)="onReadyClick()" [disabled]="validationErrors().length > 0 || isLoading()" matButton="filled"
        class="min-w-[100px]!">
        @if(isUpdateOperation()){
        Rename
        }@else{
        Create
        }
      </button>
      <a matButton="filled" class="min-w-[100px]!" routerLink="..">Cancel</a>
    </span>
  </span>
</div>
</div>
